<template>
  <section class="registration-banner" v-if="getSignupBanner">
    <h1>
      Cadastre-se agora e tenha
      <br>
      acesso gratuito a fretes mais competitivos!
    </h1>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('signup', ['getSignupBanner']),
  }
}
</script>
